import { TranslateLoader } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';

export const DEFAULT_LOCALE = 'en';

// Type for translation JSON structure
export type TranslationValue = string | { [key: string]: TranslationValue };
export type Translations = Record<string, TranslationValue>;

export interface Language {
  Name: string;
  OrthographicName: string;
  Code: string;
}

export const languages: Language[] = [
  {
    Name: 'English',
    OrthographicName: 'English',
    Code: 'en',
  },
  {
    Name: 'Spanish',
    OrthographicName: 'Español',
    Code: 'es',
  },
  {
    Name: 'Creole',
    OrthographicName: 'Kreyòl',
    Code: 'ht',
  },
  {
    Name: 'Burmese',
    OrthographicName: 'မြန်မာဘာသာ',
    Code: 'my',
  },
];

const translationLoaders: Record<string, () => Promise<Translations>> = {
  en: () => import('./en.json').then(module => module.default as Translations),
  es: () => import('./es.json').then(module => module.default as Translations),
  ht: () => import('./ht.json').then(module => module.default as Translations),
  my: () => import('./my.json').then(module => module.default as Translations),
};

export class CustomTranslateLoader implements TranslateLoader {
  // eslint-disable-next-line class-methods-use-this
  getTranslation(lang: string): Observable<Translations> {
    const loader = translationLoaders[lang] || translationLoaders[DEFAULT_LOCALE];
    return from(loader().catch(() => translationLoaders[DEFAULT_LOCALE]()));
  }
}
